import { Breadcrumb, BreadcrumbsProps } from "@/components/breadcrumbs";
import { Colors, Icons, Urls } from "@/util";

const createSeasonBreadcrumbs = (seasonCode: string, breadcrumbs: Breadcrumb[]): BreadcrumbsProps => {
    breadcrumbs = [{ text: `Seizoen ${seasonCode}`, url: Urls.season(seasonCode), icon: Icons.season }, ...breadcrumbs]
    return { color: Colors.season, breadcrumbs: breadcrumbs }
}

export default createSeasonBreadcrumbs;